/**
 * 収集運搬業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/admin-types'
import {ADMIN_TRANSPORT_RESET_CONDITION, ADMIN_TRANSPORT_RESET_PAGINATION} from "../../../mutation-types/admin-types";

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/masters/transports`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      name: null,
      subscriber_number: null,
    },
  }
}

const transport = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 収集運搬業者一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param subscriber_number
     * @param unregister_trader
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { name, subscriber_number, unregister_trader, page }) {
      dispatch('saveCondition', { name: name, subscriber_number: subscriber_number, unregister_trader: unregister_trader })
      const params = { name: state.condition.name, subscriber_number: state.condition.subscriber_number, unregister_trader: state.condition.unregister_trader, page: page }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.ADMIN_TRANSPORT, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { name, subscriber_number, unregister_trader }) {
      const _name = (name !== undefined) ? name : state.condition.name
      const _subscriber_number = (subscriber_number !== undefined) ? subscriber_number : state.condition.subscriber_number
      const _unregister_trader = (unregister_trader !== undefined) ? unregister_trader : state.condition.unregister_trader
      const params = { name: _name, subscriber_number: _subscriber_number, unregister_trader: _unregister_trader }
      commit(types.ADMIN_TRANSPORT_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.ADMIN_TRANSPORT_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.ADMIN_TRANSPORT_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.ADMIN_TRANSPORT_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.ADMIN_TRANSPORT_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.ADMIN_TRANSPORT] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_TRANSPORT_CONDITION] (state, { params }) {
      state.condition.name = params.name
      state.condition.subscriber_number = params.subscriber_number
      state.condition.unregister_trader = params.unregister_trader
    }
  },

 }

 export default transport
